<template>
    <div>
        <div v-if="loading" class="loading"/>

        <div v-else class="disable-text-selection">
            <div class="top-right-button-container">
                <b-button-group class="mb-2">
                    <b-dropdown v-if="complaint.data.attributes.status.toLowerCase() !== 'completed'"
                        size="sm" variant="outline-primary" right :text="'Actions'">
                        <b-dropdown-item v-if="complaint.data.attributes.status.toLowerCase() === 'not responded'"
                            @click="complaintRespond"  size="sm" variant="outline-primary">
                            Respond
                        </b-dropdown-item>

                        <b-dropdown-item v-if="complaint.data.attributes.status.toLowerCase() === 'responded'"
                                         @click="complaintReview" size="sm" variant="outline-primary">
                            Review
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-if="complaint.data.attributes.status.toLowerCase() === 'reviewed'"
                            @click="complaintResident" size="sm" variant="outline-primary">
                            Resident Complaint
                        </b-dropdown-item>
                    </b-dropdown>

                    <b-button size="sm" @click="printInspection" variant="outline-primary">
                        Print
                    </b-button>

                    <b-dropdown size="sm" variant="primary" right text="More">
                        <b-dropdown-item>Edit</b-dropdown-item>
                        <b-dropdown-item>Delete</b-dropdown-item>
                    </b-dropdown>
                </b-button-group>
            </div>

            <div class="d-flex flex-row">
                <span class="iconsminds-coins mr-3 menu-icon-style" style="font-size: 23px;"/>

                <piaf-breadcrumb :heading="complaint.data.attributes.code"/>

<!--                <p class="my-auto">-->
<!--                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Amet commodi dolores quod,-->
<!--                    repellendus similique sint. Ad, corporis culpa delectus est in ipsum laboriosam nostrum-->
<!--                    officiis quia quos rem totam vitae.-->
<!--                </p>-->
            </div>

            <div class="separator mb-4"/>

            <div class="mx-auto">
                <b-alert style="max-width: 830px" :show="complaintStatus.alert" :variant="complaintStatus.variant" dismissible><b>Attention! </b>
                    {{ complaintStatus.message }}
                </b-alert>

                <b-row class="invoice-vue-fixed" id="print-complaint">
                    <b-colxx md="12">
                        <b-card no-body class="invoice-contents">
                            <b-card-body class="d-flex flex-column justify-content-between">
                                <div class="d-flex flex-column">
                                    <div class="d-flex flex-row justify-content-between pt-2 pb-2">
                                        <div class="d-flex align-self-center">
                                            <img :src="`/default/logo-${themeMode === 'light' ? 'black' : 'white'}.svg`"/>
                                        </div>
                                        <div class="d-flex w-40 text-right align-self-center">
                                            <p class="text-semi-muted mb-0">
                                                NORTHBRIDGE COMMUNITY SERVICES<br>
                                                EMERGENCY HOUSING MANAGEMENT PROGRAM
                                            </p>
                                        </div>
                                    </div>

                                    <div class="border-bottom pt-4 mb-5"></div>

                                    <div class="d-flex flex-row justify-content-center mb-3">
                                        <h4><u>COMPLAINT RESPOND</u></h4>
                                    </div>

                                    <div>
                                        <b-row class="mb-0">
                                            <b-colxx>
                                                <p>Assigned To : {{
                                                    complaint.data.attributes.assigned_to.includes("-") ?
                                                    complaint.data.attributes.assigned_to.split(' - ')[1] :
                                                    complaint.data.attributes.assigned_to
                                                    }}
                                                </p>
                                            </b-colxx>
                                            <b-colxx class="text-right">
                                                <p>Date: {{ complaint.data.attributes.assigned_date }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx>
                                                <p>Complaint by : {{
                                                    complaint.data.attributes.assigned_to.includes("-") ?
                                                    complaint.data.attributes.assigned_to.split(' - ')[1] :
                                                    complaint.data.attributes.assigned_to
                                                    }}
                                                </p>
                                            </b-colxx>
                                            <b-colxx class="text-right">
                                                <p>Date: {{ complaint.data.attributes.assigned_date }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="4">
                                                <p>Client: {{ complaint.data.attributes.current_client_name }}</p>
                                            </b-colxx>
                                            <b-colxx md="4">
                                                <p>Unit : {{ complaint.data.attributes.unit }}</p>
                                            </b-colxx>
                                            <b-colxx md="4" class="text-right">
                                                <p>Phone: {{ complaint.data.attributes.current_client_phone }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="6">
                                                <p>Inspector: {{
                                                        complaint.data.attributes.assigned_to.includes("-") ?
                                                            complaint.data.attributes.assigned_to.split(' - ')[1] :
                                                            complaint.data.attributes.assigned_to
                                                    }}</p>
                                            </b-colxx>
                                            <b-colxx md="6" class="text-right">
                                                <p>Phone: {{ complaint.data.attributes.assigned_phone }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="6">
                                                <p>Facility Code: {{ complaint.data.attributes.facility_code }}</p>
                                            </b-colxx>
                                            <b-colxx md="6" class="text-right">
                                                <p>Provider Name: {{ complaint.data.attributes.vendor_name }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="12">
                                                <p>Facility Address: {{ complaint.data.attributes.facility_address }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="6">
                                                <p>Contact Person: {{ complaint.data.attributes.facility_contact }}</p>
                                            </b-colxx>
                                            <b-colxx md="6" class="text-right">
                                                <p>Phone: {{ complaint.data.attributes.facility_phone }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="6">
                                                <p>Complaint Description : {{ complaint.data.attributes.description }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="12">
                                                <p>Work Completed: {{ complaint.data.attributes.work_completed }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="6">
                                                <p>Inspector: {{
                                                        complaint.data.attributes.assigned_to.includes("-") ?
                                                            complaint.data.attributes.assigned_to.split(' - ')[1] :
                                                            complaint.data.attributes.assigned_to
                                                    }}</p>
                                            </b-colxx>

                                            <b-colxx md="6" class="text-right">
                                                <p>Date: {{ complaint.data.attributes.assigned_date }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="6">
                                                <p>Reviewer: {{ complaint.data.attributes.reviewed_by }}</p>
                                            </b-colxx>
                                            <b-colxx class="text-right">
                                                <p>Date: {{ complaint.data.attributes.review_date }}</p>
                                            </b-colxx>
                                        </b-row>
                                        <b-row>
                                            <b-colxx md="6">
                                                <p>Respond to HASA : {{ complaint.data.attributes.response_hasa }}</p>
                                            </b-colxx>
                                            <b-colxx class="text-right">
                                                <p>Date: {{ complaint.data.attributes.hasa_respond_date }}</p>
                                            </b-colxx>
                                        </b-row>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-card>
                    </b-colxx>
                </b-row>
            </div>
        </div>

        <RespondFormModal :complaint="complaint" @updated="getComplaint(complaint.complaint_id)"/>
        <ReviewFormModal :complaint="complaint" @updated="getComplaint(complaint.complaint_id)"/>
        <ResidentFormModal :complaint="complaint" @updated="getComplaint(complaint.complaint_id)"/>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import RespondFormModal from "./modals/RespondFormModal";
    import ReviewFormModal from "./modals/ReviewFormModal";
    import ResidentFormModal from "./modals/ResidentFormModal";

    export default {
        name: "ComplaintSummary",

        components: {
            ResidentFormModal,
            RespondFormModal,
            ReviewFormModal,
        },

        data() {
            return {
                loading: true,
                themeMode: localStorage.getItem('theme_selected_color').split(".")[0],
            }
        },

        computed: {
            ...mapGetters({
                complaint: 'getComplaint'
            }),

            complaintStatus() {
                if (this.complaint.data.attributes.status.toLowerCase() === 'not responded') {
                    return {
                        alert: true,
                        variant: 'warning',
                        message: 'Complaint has not been responded yet, please respond!',
                    }
                } if (this.complaint.data.attributes.status.toLowerCase() === 'responded') {
                    return {
                        alert: true,
                        variant: 'warning',
                        message: 'Complaint has not been reviewed yet, please reviewed!',
                    }
                } else if (this.complaint.data.attributes.status.toLowerCase() === 'reviewed') {
                    return {
                        alert: true,
                        variant: 'warning',
                        message: 'Resident complain has not been created, please submit resident complaint!',
                    }
                }
                else {
                    return {
                        expired: false,
                        variant: 'success',
                        message: 'Whoa! You\'re safe for now!',
                    };
                }
            },
        },

        mounted() {
            this.getComplaint(this.$route.params.complaint_id);
        },

        methods: {
            async getComplaint(complaint_id) {
                await this.$store.dispatch('fetchComplaint', complaint_id)
                    .catch(error => {
                        this.$router.push('/error');
                    });

                return this.loading = false;
            },

            complaintRespond() {
                this.$store.commit('setComplaintRespondForm');

                setTimeout(() => {
                    this.$bvModal.show('complaint_respond');
                }, 1);
            },

            complaintReview() {
                this.$store.commit('setComplaintReviewForm');

                setTimeout(() => {
                    this.$bvModal.show('complaint_review');
                }, 1);
            },

            complaintResident() {
                this.$store.commit('setComplaintResidentForm');

                setTimeout(() => {
                    this.$bvModal.show('complaint_resident');
                }, 1);
            },

            printInspection() {
                this.$htmlToPaper('print-complaint');
            }
        }
    }
</script>

<style scoped>

</style>
